import React, { useEffect } from 'react';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';
import { WORKFLOW_NUDGE_ID } from '../../../common/constants';
import { workflowNudgeEntryPoint } from './entrypoint';

const runtimeProps = {};
const entryPointParams = {};

export const WorkflowNudgeAsync = () => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		workflowNudgeEntryPoint,
		entryPointParams,
	);
	// Can't put this in the trigger as if the trigger fired before page load, then no components of entrypoint are ready to load
	// eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
	useEffect(() => {
		entryPointActions.load();
	}, [entryPointActions]);

	return (
		<JiraEntryPointContainer
			id={WORKFLOW_NUDGE_ID}
			packageName="jiraBoardOnboarding"
			entryPointReferenceSubject={entryPointReferenceSubject}
			fallback={<></>}
			runtimeProps={runtimeProps}
		/>
	);
};
